export { hr } from '@payloadcms/translations/languages/hr'
